<script>
  import CellDisplayTypes from "../lib/ResultTable/CellDisplayTypes";
  import ResultTable from "../lib/ResultTable/ResultTable.svelte";

  export let federalResult;
  export let stateResult;
  export let totalTaxableAmount;

  const headers = [
    "Tax Type",
    "Marginal Tax Rate",
    "Effective Tax Rate",
    "Tax Amount"
  ];

  $: rows = [
    [
      { value: "Federal", displayType: CellDisplayTypes.String },
      { value: federalResult.marginalRate, displayType: CellDisplayTypes.Percent },
      { value: federalResult.effectiveRate, displayType: CellDisplayTypes.Percent },
      { value: federalResult.amount, displayType: CellDisplayTypes.Money }
    ],
    [
      { value: "State", displayType: CellDisplayTypes.String },
      { value: stateResult.marginalRate, displayType: CellDisplayTypes.Percent },
      { value: stateResult.effectiveRate, displayType: CellDisplayTypes.Percent },
      { value: stateResult.amount, displayType: CellDisplayTypes.Money }
    ]
  ];

  $: total = (federalResult.amount ?? 0) + (stateResult.amount ?? 0);

  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
</script>

<ResultTable
  headers={headers}
  rows={rows}
  totalTaxableAmount={totalTaxableAmount}
  totalCapitalGainsTax={total}
  formatter={formatter}/>
